import { render, staticRenderFns } from "./MenuHeader.vue?vue&type=template&id=c159c4b4&scoped=true"
import script from "./MenuHeader.vue?vue&type=script&lang=js"
export * from "./MenuHeader.vue?vue&type=script&lang=js"
import style0 from "./MenuHeader.vue?vue&type=style&index=0&id=c159c4b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c159c4b4",
  null
  
)

export default component.exports